import { APP_ROLES, AppRole, Capability, CAPABILITIES } from '../types/rbac.types'

// Miroir LOCAL de la matrice backend (capacité -> rôle minimal). La source de
// vérité au runtime reste le tableau `capabilities` renvoyé par
// /me/app-role ; ce miroir sert au typage, aux libellés et aux tests
// anti-dérive (capabilities.test.ts encode la matrice en chaînes littérales).
export const CAPABILITY_MIN_ROLE: Record<Capability, AppRole> = {
  read: 'viewer',
  'relay.read': 'viewer',
  'relay.command': 'operator',
  'fleet.push': 'operator',
  'planbt.sync': 'viewer',
  'fleet.edit': 'editor',
  'fleet.pull': 'editor',
  'planbt.edit': 'editor',
  'equipment.edit': 'editor',
  'fleet.delete': 'admin',
  'planbt.delete': 'admin',
  'minigrid.delete': 'admin',
  'users.manage': 'admin',
}

// Commandes du command bus accordées au lecteur (`relay.read`). Liste
// EXPLICITE, miroir de api-data-platform utils/rbac/commands.go
// (RelayReadCommands) : pas un préfixe `read_`. read_appkey et
// read_lorawan_parameters sont volontairement exclues (exposition de l'AppKey,
// secret LoRaWAN : la réponse DI A075 de read_lorawan_parameters contient
// app_key) ; elles et toute commande inconnue ou future relèvent de
// `relay.command`.
export const RELAY_READ_COMMANDS: ReadonlySet<string> = new Set([
  'read_relay',
  'read_time',
  'read_date',
  'read_frq_plan',
  'read_report_interval',
  'read_protocol_version',
])

// Capacité exigée pour envoyer une commande (correspondance exacte).
export const capabilityForCommand = (name: string): Capability =>
  RELAY_READ_COMMANDS.has(name) ? 'relay.read' : 'relay.command'

export const ROLE_RANK: Record<AppRole, number> = {
  viewer: 1,
  operator: 2,
  editor: 3,
  admin: 4,
}

export const isAppRole = (value: unknown): value is AppRole =>
  typeof value === 'string' && (APP_ROLES as readonly string[]).includes(value)

export const isCapability = (value: unknown): value is Capability =>
  typeof value === 'string' && (CAPABILITIES as readonly string[]).includes(value)

// Hiérarchie cumulative viewer ⊂ operator ⊂ editor ⊂ admin. Rôle absent ou
// inconnu => aucune capacité (fail-closed).
export const hasCapability = (
  role: AppRole | '' | null | undefined,
  capability: Capability,
): boolean => {
  if (!isAppRole(role)) return false
  return ROLE_RANK[role] >= ROLE_RANK[CAPABILITY_MIN_ROLE[capability]]
}

export const capabilitiesForRole = (role: AppRole | '' | null | undefined): Capability[] =>
  CAPABILITIES.filter((c) => hasCapability(role, c))
